import React, { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';

import PageFallback from 'components/PageFallback';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { setUserRegistry } from 'stores/user';
import { AccountService } from 'services';
import { isUserAdmin } from 'utils/auth';
import { UserRolesTypes } from 'common/user-role-types';

const accountService = new AccountService();

const Login = () => {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePersonInfo = async () => {
    const loggedUserInfo = await accountService.getMe();
    dispatch(setUserRegistry(loggedUserInfo));
    if (isUserAdmin()) {
      navigate('/admin');
    } else if (loggedUserInfo?.registerStatusType === 'PENDING') {
      navigate('/bem-vindo');
    } else if (loggedUserInfo?.roles?.includes(UserRolesTypes.CUSTOMER_OWNER) && loggedUserInfo?.isFirstAccess) {
      navigate('/primeiro-acesso/usuarios/novo');
    } else {
      navigate('/contratar');
    }
  };

  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated) {
        handlePersonInfo();
      } else {
        keycloak.login();
      }
    }
  }, [initialized, keycloak]);

  return <PageFallback />;
};

export default Login;
